module.exports = __webpack_public_path__ + "static/images/new-user.c973d6cad13e7bd13059d0e91ffe8854.svg";